import { useEventCallback } from "usehooks-ts";

import { useDispatch, useSelector } from "@/redux/hooks";
import {
  dismiss as dismissToast,
  notify as notifyToast,
  Toast,
  ToastType,
} from "@/redux/slices/toasts";
import { AppState } from "@/redux/store";

/**
 * Toast alerts
 *
 * Example usage:
 *
 * const { notify, dismiss } = useToast();
 * const id = notify("A toast", ToastType.Error);
 * dismiss(id);
 */
export const useToast = (): {
  dismiss: (id: string) => void;
  instances: Toast[];
  notify: (message: React.ReactNode, type: ToastType) => string;
} => {
  const dispatch = useDispatch();
  const instances = useSelector((state: AppState) => state.toasts.toasts);
  const dismiss = useEventCallback((id: string) => {
    dispatch(dismissToast(id));
  });
  const notify = useEventCallback(
    (message: React.ReactNode, type: ToastType) => {
      const id = Math.random().toString(36).substring(7);
      dispatch(notifyToast({ id, message, type }));
      return id;
    },
  );

  return {
    dismiss,
    instances,
    notify,
  };
};
